module.exports = __webpack_public_path__ + "img/album15_10.f4db5bfb.jpg";